import http from 'util/http'
import axios from 'axios'
import Cookies from 'js-cookie'
import env from '@env'

const examBaseURL = env.exam

/**
 * @description 获取进阶课程列表
 */
export function getLessons(params?: object) {
  return http.get(
    '/advancedLessons',
    {
      ...params,
    },
    {
      baseUrl: examBaseURL,
    },
  )
}
/*
 * @description 获取学习关卡模板详情
 */
export function getCheckTemplate(params?: any, opts?: any) {
  return http.get(
    '/studyCheckTemplate',
    {
      ...params,
      // with_check_tasks:true
    },
    {
      baseUrl: examBaseURL,
      structure: 'data',
      ...opts,
    },
  )
}

/**
 * @description 获取用户闯关记录列表
 */
export function getUserCheckRecord(params?: any) {
  return http.get(
    '/user/studyCheckRecords',
    {
      ...params,
    },
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

/**
 * @description 获取单个关卡详情
 */
export function getSingleCheckDetails(params?: any) {
  return http.get(
    `/studyChecks/${params.id}`,
    {},
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

export function getImportableTemplates(param, extra?) {
  return http.get('/user/importable/studyCheckTemplates', param, {
    baseUrl: examBaseURL,
    extra,
  })
}

/*
 * @description 获取学习关卡任务执行记录详情
 */
export function getCheckTaskRecordDetail(id) {
  return http.get(
    `/studyCheckTaskRecords/${id}`,
    {},
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

/*
 * @description 获取闯关记录详情
 */
export function getCheckTaskRecords(id) {
  return http.get(
    `/studyCheckRecords/${id}`,
    {},
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

export function getCheckTaskRecordAnswer(id) {
  return http.get(
    `studyCheckTaskRecords/${id}/exam/answerCards`,
    {},
    {
      baseUrl: examBaseURL,
    },
  )
}

/*
 * @description 获取学习关卡任务执行记录详情
 */
export function getCheckTaskRecord(id) {
  return http.get(
    `/user/studyCheckTaskRecords/${id}/status`,
    {},
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

/**
 * @description 获取关卡模板更新信息
 */
export function getTemplUpdateInfo(params?: any, opts?: any) {
  return http.get(
    '/studyCheckTemplate/updateInfo',
    {
      ...params,
    },
    {
      baseUrl: examBaseURL,
      structure: 'data',
      ...opts,
    },
  )
}

/**
 * @description 发布学习关卡模板
 */
export function publishCheckTemplate(params) {
  return axios({
    method: 'post',
    url: examBaseURL + '/published/studyCheckTemplates',
    data: {
      ...params,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      token: Cookies.get('AUTHOR_TOKEN'),
      // token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI0MmE3ZDk4YTIwNTViYWQ3MmY2M2ZiYTRlNDA1Y2NlNSIsImlzcyI6Imh0dHBzOlwvXC9vYS5qaW5nemh1YW4uY24iLCJhdWQiOiIiLCJpYXQiOjE1NTczOTgzMzksImV4cCI6MTU1OTk5MDMzOSwidXNlcl9pZCI6NTE4NzYsImtleSI6ImNvbGxlZ2UifQ.1CgIjSM8NkThs_AGJIsk06iOve0EQdqkQyaViO2l374" || Cookies.get('AUTHOR_TOKEN'),
      project: 'soft',
    },
  })
}
/**
 * @description 新增学习关卡模板
 */
export function addCheckTemplate(params) {
  return http.post(
    '/studyCheckTemplates',
    { ...params },
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}
/**
 * @description 修改学习关卡模板
 */
export function updateCheckTemplate(id, params) {
  return http.post(
    `/studyCheckTemplates/${id}`,
    { ...params, _method: 'patch' },
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

/**
 *  提交某个学习关卡任务执行记录的的某个习题答案
 * @param recordId 记录id
 * @param titleId 习题id
 * @param answers 答案
 */
export function postTitleAnswers(recordId, titleId, answers) {
  return http.post(
    `/studyCheckTaskRecords/${recordId}/exampleTitles/${titleId}/answers`,
    { answers },
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

/**
 * 学习关卡考试任务交卷
 * @param recordId 记录id
 * @param answers 答案列表
 */
export function submitExamPaper(recordId, answers) {
  return http.post(
    `studyCheckTaskRecords/${recordId}/examTitles/answers`,
    {
      answers,
    },
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

/**
 * @description 获取试题列表
 */
export function getExamList(payload) {
  return http.get('/examTitles', payload, {
    baseUrl: examBaseURL,
    structure: 'data',
  })
}

/**
 * @description 获取用户的可选题目列表
 */
export function getSelectableExamList(payload) {
  return http.get('/user/studyChecks/selectableTitles', payload, {
    baseUrl: examBaseURL,
    structure: 'data',
  })
}
/**
 * @description 获取视频列表
 */
export function getVideoList(payload) {
  return http.get('/article/video', payload, {
    baseUrl: examBaseURL,
    structure: 'data',
  })
}

/**
 * @description 获取进阶课程中员工的基本信息
 */
export function getStaffInfo() {
  return http.get(
    '/user/advancedLessons/staff/basic',
    {},
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

/**
 * @description 获取我的进阶课程列表
 */
export function getUserLessons() {
  return http.get(
    '/user/advancedLessons',
    {},
    {
      baseUrl: examBaseURL,
    },
  )
}

/**
 * @description 获取我的团队员工的学习关卡通关情况
 */
export function getUserStaffChecks(params?: {
  lession_id?: number
  staff_id?: number
  per_page?: number
  page?: number
}) {
  return http.get(
    '/user/staff/studyCheckCards',
    {
      per_page: 5,
      page: 1,
      ...params,
    },
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

export function postAdvancedVideo(payload, opts?) {
  return http.post('/newxy/public/advance/article', payload, opts)
}

export function getAdvancedVideo(payload) {
  return http.get(
    '/newxy/public/advance/article/list',
    {
      pageindex: 1,
      pagesize: 5,
      ...payload,
    },
    {},
  )
}

export function deleteAdvancedVideo(id) {
  return http.post(`/newxy/public/advance/del/article`, { id })
}

export function getAdvancedExample(payload) {
  return http.get(
    '/studyCheckCustomTitles',
    {
      page: 1,
      per_page: 5,
      ...payload,
    },
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

export function addAdvancedExample(payload: {
  content: string
  answers: string[]
}) {
  return http.post('/studyCheckCustomTitles', payload, {
    baseUrl: examBaseURL,
  })
}

export function updateAdvancedExample(
  id: string,
  payload: {
    content: string
    answers: string[]
  },
) {
  return http.post(
    `/studyCheckCustomTitles/${id}`,
    {
      ...payload,
      _method: 'patch',
    },
    {
      baseUrl: examBaseURL,
    },
  )
}

export function deleteAdvancedExample(id: string) {
  return http.post(
    `/studyCheckCustomTitles/${id}`,
    {
      _method: 'delete',
    },
    {
      baseUrl: examBaseURL,
    },
  )
}

// 获取当前账号当前课程类型下的关卡角色列表
export function getCheckRoles(param: {
  lesson_id?: number
  keyword?: string
  page?: number
  per_page: number
}) {
  return http.get(`/user/studyCheckRoles`, param, {
    baseUrl: examBaseURL,
    structure: 'data',
  })
}

// 获取当前部门下的角色配置列表
export function getDepartmentRoles(param, extra?) {
  return http.get('/user/departmentConfig/studyCheckRoles', param, {
    baseUrl: examBaseURL,
    structure: 'data',
    ...extra,
  })
}

// 新增关卡角色
export function addCheckRole(param: {
  name: string
  order?: number
  lesson_id: number
}) {
  return http.post('/studyCheckRoles', param, {
    baseUrl: examBaseURL,
  })
}

// 编辑关卡角色
export function updateCheckRole(
  id,
  param: {
    name?: string
    order?: number
    lesson_id?: number
  },
) {
  return http.post(`/studyCheckRoles/${id}`, param, {
    baseUrl: examBaseURL,
  })
}

// 删除关卡角色
export function deleteCheckRole(id) {
  return http.post(
    `/studyCheckRoles/${id}`,
    {
      _method: 'delete',
    },
    {
      baseUrl: examBaseURL,
    },
  )
}

// 获取关卡角色详情
export function getCheckRole(id: string) {
  return http.get(
    `/studyCheckRoles/${id}`,
    {},
    {
      baseUrl: examBaseURL,
    },
  )
}

// 获取我的可通关员工列表
export function getPassableStaffs(param) {
  return http.get(`/user/studyCheckRoles/passableStaff`, param, {
    baseUrl: examBaseURL,
    structure: 'data',
  })
}

// 绑定员工到学习关卡角色
export function bindStaffs(roleId, param) {
  return http.post(
    `/studyCheckRoles/${roleId}/boundStaffs`,
    {
      ...param,
      _method: 'put',
    },
    {
      baseUrl: examBaseURL,
    },
  )
}

// 解绑员工到学习关卡角色
export function unbindStaffs(param) {
  return http.post(
    `/studyCheckRoles/unbindStaffs`,
    {
      ...param,
      _method: 'put',
    },
    {
      baseUrl: examBaseURL,
    },
  )
}

// 获取收藏的关卡
export function getFavoritesTemplate(param, extra) {
  return http.get(`/user/collected/studyCheckTemplates`, param, {
    baseUrl: examBaseURL,
    structure: 'data',
  })
}

// 添加收藏的关卡
export function addFavoritesTemplate(param, extra?) {
  return axios({
    url: examBaseURL + '/collected/studyCheckTemplates',
    method: 'post',
    data: {
      ...param,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      token: Cookies.get('AUTHOR_TOKEN'),
      // token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI0MmE3ZDk4YTIwNTViYWQ3MmY2M2ZiYTRlNDA1Y2NlNSIsImlzcyI6Imh0dHBzOlwvXC9vYS5qaW5nemh1YW4uY24iLCJhdWQiOiIiLCJpYXQiOjE1NTczOTgzMzksImV4cCI6MTU1OTk5MDMzOSwidXNlcl9pZCI6NTE4NzYsImtleSI6ImNvbGxlZ2UifQ.1CgIjSM8NkThs_AGJIsk06iOve0EQdqkQyaViO2l374" || Cookies.get('AUTHOR_TOKEN'),
      project: 'soft',
    },
  })
}

// 编辑收藏的关卡
export function updateFavoritesTemplate(id, param, extra) {
  return http.post(
    `/studyCheckTemplates/${id}`,
    {
      ...param,
      _method: 'patch',
    },
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

// 获取单个关卡的模板详情
export function previewStudyCheckRecords(id) {
  return http.get(
    `/studyCheckTemplates/preview/studyCheckRecords/${id}`,
    {},
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}
// 删除收藏的关卡
export function removeFavoritesTemplate(id, extra?) {
  return http.post(
    `/studyCheckTemplates/${id}`,
    {
      _method: 'delete',
    },
    {
      baseUrl: examBaseURL,
      ...extra,
    },
  )
}

// 添加模板草稿
export function addTemplateDraft(param, extra?) {
  return axios({
    url: examBaseURL + '/saved/studyCheckTemplates',
    method: 'post',
    data: {
      ...param,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      token: Cookies.get('AUTHOR_TOKEN'),
      // token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI0MmE3ZDk4YTIwNTViYWQ3MmY2M2ZiYTRlNDA1Y2NlNSIsImlzcyI6Imh0dHBzOlwvXC9vYS5qaW5nemh1YW4uY24iLCJhdWQiOiIiLCJpYXQiOjE1NTczOTgzMzksImV4cCI6MTU1OTk5MDMzOSwidXNlcl9pZCI6NTE4NzYsImtleSI6ImNvbGxlZ2UifQ.1CgIjSM8NkThs_AGJIsk06iOve0EQdqkQyaViO2l374" || Cookies.get('AUTHOR_TOKEN'),
      project: 'soft',
    },
  })
}

// 预览学习关卡模板
export function previewCheckTemplate(param, extra) {
  return axios({
    url: examBaseURL + '/studyCheckTemplates/preview/studyCheckRecords',
    method: 'post',
    data: {
      ...param,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      token: Cookies.get('AUTHOR_TOKEN'),
      // token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI0MmE3ZDk4YTIwNTViYWQ3MmY2M2ZiYTRlNDA1Y2NlNSIsImlzcyI6Imh0dHBzOlwvXC9vYS5qaW5nemh1YW4uY24iLCJhdWQiOiIiLCJpYXQiOjE1NTczOTgzMzksImV4cCI6MTU1OTk5MDMzOSwidXNlcl9pZCI6NTE4NzYsImtleSI6ImNvbGxlZ2UifQ.1CgIjSM8NkThs_AGJIsk06iOve0EQdqkQyaViO2l374" || Cookies.get('AUTHOR_TOKEN'),
      project: 'soft',
    },
  })
}
